import { render } from "./UnitInfo_content_reefer.vue?vue&type=template&id=42b99cb9&scoped=true"
import script from "./UnitInfo_content_reefer.vue?vue&type=script&lang=js"
export * from "./UnitInfo_content_reefer.vue?vue&type=script&lang=js"

import "./UnitInfo_content_reefer.vue?vue&type=style&index=0&id=42b99cb9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42b99cb9"]])

export default __exports__